import { getProductIntegerId } from '~/js/utilities/product';

const bundleBuilderForm = () => ({
  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  },

  get buttonLabel() {
    if (this.isWorking) {
      return 'Adding...';
    }

    if (this.isProductInBundle) {
      return 'Added';
    }

    if (this.buttonLabelBase === 'Add to Cart') {
      return 'Add to Bundle';
    }

    return this.buttonLabelBase;
  },

  get isProductInBundle() {
    if (this.isButtonDisabled) return true;

    // Check if the product is already in the cart
    const parentID = getProductIntegerId(
      this.product?.parentProductId
    ).toString();
    const productID = getProductIntegerId(this.product?.id).toString();
    const count = this.bundle
      ?.map((item) => item.split(':'))
      .filter(
        (item) => item.includes(parentID) || item.includes(productID)
      ).length;

    const isStepInCart = this.bundle?.some((item) =>
      item.includes(`:step-${this.product.step}`)
    );

    if (isStepInCart) return true;
    return count < (this.extraItemsLimit || 1) ? false : true;
  },

  get qualifiersParsed() {
    const { qualifiers } = this.product;
    if (!qualifiers?.value) return '';
    try {
      return JSON.parse(qualifiers.value).join(' ');
    } catch (e) {
      return '';
    }
  },

  get metafieldPoweredTitle() {
    const { print, description, type } = this.product;

    return Boolean(
      print?.value &&
        ((this.qualifiersParsed && type?.value) || description?.value)
    );
  },

  get superTitle() {
    const { brand, print } = this.product;

    const brandNormalized =
      brand?.value && !brand.value.includes('Posh Peanut') ? brand.value : '';

    return `${brandNormalized ? `${brandNormalized} ` : ''}${print?.value}`;
  },

  get title() {
    const { description } = this.product;
    if (description?.value) return description.value;

    return `${this.qualifiersParsed} ${this.product.type.value}`;
  },

  get legacyTitle() {
    return this.product.title;
  },

  async addToBundle() {
    if (this.isWorking) return;

    const { selectedVariants, product } = this;
    const [selectedVariant] = selectedVariants;

    await this.addProductToBundle(product.id, selectedVariant.id, product.step);
    const nextStep = document.getElementById(`product-${product.step + 1}`);

    if (nextStep) {
      nextStep.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  },

  async handleButtonClick() {
    const { stateBase } = this;

    if (stateBase === 'app-exclusive') {
      window.open('https://wn4uoivx.tapc.art');
      return;
    }

    if (stateBase === 'sold-out-notify' || stateBase === 'coming-soon') {
      this.$dispatch('open-quick-add-drawer', {
        product: this.product,
        selectedOptions: this.selectedOptions,
      });

      return;
    }

    if (stateBase === 'many-variants') {
      const missingOption = Object.entries(this.selectedOptions).find(
        ([, value]) => value === ''
      )?.[0];
      this.$root
        .querySelector(`[data-option-name="${missingOption}"]`)
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

      return;
    }

    await this.addToBundle();
    this.isWorking = false;
  },

  handleBundleBuilderClearForm() {
    const selectedOptions = Object.fromEntries(
      this.product.options.map((option) => [option.name, ''])
    );
    this.normalizeOptionsAndVariants(Object.entries(selectedOptions));
  },
});

export default bundleBuilderForm;
